import { useMemo } from "react";
import { useManualAuthoringStore } from "../../store/manualAuthoringStore";
import { useUserStore } from "../../store/userStore";
import { useAuthoringStore } from "../../store/UseAuthorStore";
import "bootstrap-icons/font/bootstrap-icons.css";

type Props = {
  onSave: () => void;
  onExportPdf: () => void;
  isSaving: boolean;
};

export default function ManualAuthoringHeader({
  onSave,
  onExportPdf,
  isSaving,
}: Props) {
  const manual = useManualAuthoringStore((s) => s.presentManual);
  const selectedSectionId = useManualAuthoringStore(
    (s) => s.selectedSectionId
  );
  const selectedSubSectionId = useManualAuthoringStore(
    (s) => s.selectedSubSectionId
  );

  const undo = useManualAuthoringStore((s) => s.undo);
  const redo = useManualAuthoringStore((s) => s.redo);
  const manualTitle = useManualAuthoringStore((s) => s.manualTitle);

  const user = useUserStore((s) => s.user);
  const partNumber = useAuthoringStore((s) => s.partNumber);

  /* ---------------- ACTIVE SECTION INFO ---------------- */

  const activeSection = useMemo(
    () => manual.sections.find((s) => s.id === selectedSectionId),
    [manual.sections, selectedSectionId]
  );

  const activeSubSection = useMemo(
    () =>
      activeSection?.subSections?.find(
        (s) => s.id === selectedSubSectionId
      ),
    [activeSection, selectedSubSectionId]
  );

  /* ---------------- DISPLAY VALUES ---------------- */

  const manualName = manualTitle || "Manual";

  console.log("ManualAuthoringHeader", {
    partNumber,
    manualTitle,
    manualName,
    user,
  });

  return (
  <div className="manual-authoring-header px-4 py-2 border-bottom bg-light d-flex justify-content-between align-items-center">

    {/* LEFT SIDE — CLEAR CONTEXT */}
    <div className="d-flex align-items-center flex-wrap small">

      <span className="fw-semibold text-dark">
        Part Number: {partNumber}
      </span>

      <span className="mx-3 text-secondary">•</span>

      <span className="text-muted">
        Manual: {manualName}
      </span>

      {activeSection && (
        <>
          <span className="mx-3 text-secondary">•</span>
          <span className="text-muted">
            Section: {activeSection.title}
          </span>
        </>
      )}

      {activeSubSection && (
        <>
          <span className="mx-3 text-secondary">•</span>
          <span className="text-muted">
            Subsection: {activeSubSection.title}
          </span>
        </>
      )}

    </div>

    {/* RIGHT SIDE — ACTIONS */}
    <div className="d-flex align-items-center gap-2">

      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={undo}
      >
        Undo
      </button>

      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={redo}
      >
        Redo
      </button>

      <button
        className={`btn btn-sm ${isSaving ? "btn-secondary" : "btn-primary"}`}
        onClick={onSave}
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Save"}
      </button>

      <button
        className="btn btn-sm btn-outline-primary"
        onClick={onExportPdf}
      >
        PDF
      </button>

    </div>
  </div>
);


}
